import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';

import authService from "../../domain/services/AuthService";
import { registerByEmailStateSelector } from "./selectors";
import { RegisterEmailErrorCodeEnum } from "../../domain/enums/RegisterEmailErrorEnum";
import { setProcessingLoaderVisibility } from "../../../layout/store/actions";

const namespace = 'REGISTER_BY_EMAIL';

export const setEmail = createAction(`${namespace}/SET_EMAIL`);
export const setPassword = createAction(`${namespace}/SET_PASSWORD`);
export const setFormErrors = createAction(`${namespace}/SET_FORM_ERRORS`);
export const setConfirmPassword = createAction(`${namespace}/SET_CONFIRMATION_PASSWORD`);

export const emailRegisterRequest = createAction(`${namespace}/EMAIL_REGISTER_REQUEST`);
export const emailRegisterSuccess = createAction(`${namespace}/EMAIL_REGISTER_SUCCESS`);
export const emailRegisterFailed = createAction(`${namespace}/EMAIL_REGISTER_FAILED`);

export function registerByEmail() {
  return (dispatch, getState) => {

    dispatch(batchActions([
      emailRegisterRequest(),
      setProcessingLoaderVisibility(true)
    ]));

    const { email, password, confirmPassword } = registerByEmailStateSelector(getState());

    if ((password || confirmPassword) && password !== confirmPassword) {
      let formErrors = {
        confirmPassword: RegisterEmailErrorCodeEnum.PasswordsNotMatch
      };

      dispatch(batchActions([
        setFormErrors(formErrors),
        emailRegisterFailed({
          code: RegisterEmailErrorCodeEnum.PasswordsNotMatch
        }),
        setProcessingLoaderVisibility(false)
      ]));
      return;
    }

    authService.registerWithEmail({ email, password })
      .then((response) => dispatch(emailRegisterSuccess(response)))
      .catch((error) => {
        let formErrors = {};
        switch (error.code) {
          case RegisterEmailErrorCodeEnum.EmailAlreadyInUse:
          case RegisterEmailErrorCodeEnum.InvalidEmail:
            formErrors['email'] = error.code;
            break;
          case RegisterEmailErrorCodeEnum.OperationNotAllowed:
            formErrors['form'] = error.code;
            break;
          case RegisterEmailErrorCodeEnum.WeakPassword:
            formErrors['password'] = error.code;
            break;
        }

        dispatch(batchActions([
          setFormErrors(formErrors),
          emailRegisterFailed(error),
          setProcessingLoaderVisibility(false)
        ]));
      });
  };
}


// WEBPACK FOOTER //
// ./src/app/modules/auth/store/register-by-email/actions.ts